import React, { Component, Fragment, useEffect, useMemo, useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";

import { ReactComponent as ArrowLeft } from "../../assets/icons/arrow_left.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow_down.svg";

import { ReactComponent as ProgramIcon } from "../../assets/icons/program.svg";
import { ReactComponent as ActionIcon } from "../../assets/icons/block.svg";
import { ReactComponent as ConfigIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as DatasetIcon } from "../../assets/icons/folder.svg";
import { ReactComponent as ModelIcon } from "../../assets/icons/hub.svg";
import { ReactComponent as WorkerIcon } from "../../assets/icons/worker.svg";
import { ReactComponent as GeneralIcon } from "../../assets/icons/general.svg";
import { ReactComponent as DesktopIcon } from "../../assets/icons/desktop.svg";
import { ReactComponent as GameIcon } from "../../assets/icons/game.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as GamepadIcon } from "../../assets/icons/gamepad.svg";
import { ReactComponent as StreamIcon } from "../../assets/icons/stream.svg";
import { ReactComponent as CalibrateIcon } from "../../assets/icons/calibrate.svg";
import { ReactComponent as DeviceIcon } from "../../assets/icons/devices.svg";
import { ReactComponent as ListIcon } from "../../assets/icons/format_list_numbered.svg";
import { ReactComponent as TimeseriesIcon } from "../../assets/icons/timeseries.svg";
import { ReactComponent as RulerIcon } from "../../assets/icons/ruler.svg";
import { ReactComponent as CollectionIcon } from "../../assets/icons/collection.svg";
import { ReactComponent as DescriptionIcon } from "../../assets/icons/description.svg";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg";
import { ReactComponent as ChartIcon } from "../../assets/icons/signal_cellular_alt.svg";
import { ReactComponent as DataIcon } from "../../assets/icons/data.svg";
import { ReactComponent as ReportIcon } from "../../assets/icons/dashboard_customize.svg";


import Tab from "./Tab";
import { useKioskMode } from "../../context/KioskModeContext";
import { useModuleAccess } from "../../hooks/useModuleAccess";

type TabsProps = {
  className?: string;
  title?: string;
  path?: string;
  children?: any;
  data?: any;
};

const getIcon = (icon) => {
  switch (icon) {
    case "Programs":
      return <ProgramIcon />;
    case "Actions":
      return <ActionIcon />;
    case "Config":
      return <ConfigIcon />;
    case "Datasets":
      return <DatasetIcon />;
    case "Models":
      return <ModelIcon />;
    case "Workers":
      return <WorkerIcon />;
    case "General":
      return <GeneralIcon />;
    case "Monitor":
      return <DesktopIcon />;
    case "Manual":
      return <GameIcon />;
    case "Program":
      return <ProgramIcon />;
    case "Settings":
      return <SettingsIcon />;
    case "Control":
      return <GamepadIcon />;
    case "Stream":
      return <StreamIcon />;
    case "Chat":
      return <WorkerIcon />;
    case "Calibration":
      return <CalibrateIcon />;
    case "Block-Libraries":
      return <CollectionIcon />;
    case "Devices":
      return <DeviceIcon />;
    // MES sections. Every section gets a distinct icon; three of these
    // previously fell through to the default and rendered as an arrow.
    case "Planiranje":
      return <ListIcon />;
    case "Izvrsavanje":
      return <ProgramIcon />;
    case "Razvoj":
      return <ActionIcon />;
    case "Laboratorij":
      return <RulerIcon />;
    case "Skladiste":
      return <CollectionIcon />;
    case "Kvaliteta":
      return <CalibrateIcon />;
    case "Pracenje":
      return <TimeseriesIcon />;
    case "Financije":
      return <ChartIcon />;
    case "Baza":
      return <DataIcon />;
    case "Nabava":
      return <DescriptionIcon />;
    case "Pregled":
      return <DashboardIcon />;
    case "Izvjestaji":
      return <ReportIcon />;
    default:
      return <ArrowDown />;
  }
};

const Tabs = (props: TabsProps) => {
  const { isKioskMode } = useKioskMode();
  const { filterSidebarSections } = useModuleAccess();
  const fullPathName = window.location.pathname;
  const clipedPathName = fullPathName.split("/").pop();

  // Every MES page passes `mes_tab_data` in directly, so gating the sections
  // here covers all of them at once.
  const visibleData = useMemo(
    () => filterSidebarSections(props.data),
    [props.data, filterSidebarSections]
  );

  // Hide tabs in kiosk mode
  if (isKioskMode) {
    return null;
  }

  return (
    <div className="tabs">
      <div className="sidebar">
        {visibleData && (
          <ol className="list">
            {visibleData.map((tab, index) => (
              <Tab
                id={tab.id}
                path={tab.path}
                icon={getIcon(tab.title)}
                title={tab.title}
                activeTab={clipedPathName}
                useRouteMatch={tab.dynamicRoute && tab.dynamicRoute}
                subItems={tab.subItems}
                key={index}
              />
            ))}
          </ol>
        )}
        <div>{props.children}</div>
      </div>
    </div>
  );
};

export default Tabs;
